
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/team/profile",
      function () {
        return require("private-next-pages/team/profile.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/team/profile"])
      });
    }
  